import { BooleanSchema } from ".."

export const boolean = () => new BooleanSchema()
